import type React from 'react';
import { createContext } from 'react';
import type { PathMatch, PathRouteProps } from 'react-router';
import type { useLocation } from 'react-router-dom';

import type { ListItemButtonProps } from '@mui/material';

import type { Permission } from '../../features/auth/types/Permissions';
import type { RoleSet } from '../../features/auth/types/Roles';

type Location = ReturnType<typeof useLocation>;

export interface SecondaryActionWithItemProps extends Pick<PathRouteProps, 'path'> {
  match: PathMatch;
  location: Location;
}

export interface IMenuObject extends Omit<PathRouteProps, 'children'> {
  primary?: string | null;
  to?: string;
  icon?: React.ReactNode;
  props?: Partial<ListItemButtonProps>;
  children?: IMenuObject[];
  secondaryAction?: React.ComponentType<SecondaryActionWithItemProps>;
  requiredPermission?: Permission;
  requiredRole?: RoleSet;
}

export type CheckFunc = (item: IMenuObject) => boolean;

export interface IContext {
  mobileOpen: boolean;
  toggleDrawer?: () => void;
  checkContext?: CheckFunc;
  setCheckContext?: (checkFunc: CheckFunc) => void;
  menus: IMenuObject[];
}

export const defaultState: IContext = {
  mobileOpen: false,
  menus: [],
};

export const Context = createContext<IContext>(defaultState);

export default Context;
